<template>
  <div class=" flex justify-center z-50 fixed w-full">
    <div class="shadow-md w-full bg-dark rounded-full">
      <div class="flex items-center justify-between bg-purple py-2 px-6 lg:py-[1rem] lg:px-[5rem]">

        <div class="font-semibold text-2xl cursor-pointer flex items-center gap-1">
          <span class="text-white text-sm">
            <NuxtLink to="/">
              <img src="../../assets/logo-branca.png" alt="Logotipo do Laboratório Ser" class="w-10 laptop:w-16" />
            </NuxtLink>
          </span>
        </div>

        <div class="flex items-center justify-end gap-3">
          <!-- Ícone do Menu -->
          <div>
            <div class="flex items-center justify-center gap-2.5">
              <div class="cursor-pointer text-white text-2xl m-0 laptop:hidden">
                <img src="../../assets/profile-icon.svg" alt="Ícone de perfil">
              </div>
              <div @click="toggleMenu" class="cursor-pointer text-white text-2xl m-0 laptop:hidden">
                <img src="../../assets/menu-icon.svg" alt="Menu do site">
              </div>
            </div>


            <!-- Links do Menu -->
            <ul :class="[
              'font-medium text-sm flex-col lg:flex lg:flex-row lg:items-center lg:justify-between lg:pb-0 absolute lg:static bg-purple text-white lg:z-auto left-0 w-full lg:w-auto lg:pl-0 pl-6 transition-all duration-500 ease-in-out z-[-1]',
              isOpen ? 'top-[45px] opacity-100' : 'top-[-500px] opacity-0',
            ]" class="lg:opacity-100 lg:top-0">

              <li class="lg:ml-5 lg:my-0 my-3 font-bold">
                <NuxtLink to="/" @click="toggleMenu">
                  <ButtonHeader title="Home" />
                </NuxtLink>
              </li>
              <li class="lg:ml-5 lg:my-0 my-3 font-bold">
                <NuxtLink to="/sobre-mim" @click="toggleMenu">
                  <ButtonHeader title="Idealizadora" />
                </NuxtLink>
              </li>
              <li class="lg:ml-5 lg:my-0 my-3 font-bold">
                <NuxtLink to="/nossa-abordagem" @click="toggleMenu">
                  <ButtonHeader title="Nossa abordagem" />
                </NuxtLink>
              </li>
              <li class="lg:ml-5 lg:my-0 my-3 font-bold">
                <NuxtLink to="/blog" @click="toggleMenu">
                  <ButtonHeader title="Blog" />
                </NuxtLink>
              </li>

              <li class="lg:ml-5 lg:my-0 my-3 font-bold">
                <NuxtLink to="/psicologas" @click="toggleMenu">
                  <ButtonHeader title="Psicólogas" />
                </NuxtLink>
              </li>
              <li class="lg:ml-5 lg:my-0 my-3 font-bold">
                <NuxtLink to="/login" @click="toggleMenu">
                  <ButtonHeader title="Acesso Cliente" />
                </NuxtLink>
              </li>
              <li class="lg:ml-5 lg:my-0 my-3 font-bold">
                <a :href="link" @click="toggleMenu">
                  <ButtonHeader title="Acesso Profissional" />
                </a>
              </li>

            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import ButtonHeader from "./ButtonHeader.vue";

const runtimeConfigs = useRuntimeConfig()

export default {
  components: {
    FontAwesomeIcon,
    ButtonHeader,
  },
  setup() {
    const isOpen = ref(false);
    const link = ref(runtimeConfigs.public.API_URL)

    const toggleMenu = () => {
      isOpen.value = !isOpen.value;
    };

    return {
      isOpen,
      toggleMenu,
      link
    };
  },
};
</script>

<style scoped>
/* Adicione estilos personalizados se necessário */
</style>
